import {useRef, useState} from 'react';

import {latestStore} from "../stores";

import ScrollImage from "./ScrollImage";
import useIsVisible from './useIsVisible';
import business from '../stores/latestStore/business';

function ScrollRow(props) {
  const {rowNr, isLast} = props;

  const [didWarning, setDidWarning] = useState(false);

  const rowRef = useRef();
  const isRowVisible = useIsVisible(rowRef);

  const thumbnailSize = latestStore.getThumbnailSize();

  const row = latestStore.getRow(rowNr);

  // collect the cursor for the last image
  let latestCursor = '';
  const rowImages = row?.map(imageInfo => {
    const {cursor} = imageInfo;
    latestCursor = cursor;

    const enhancedImageInfo = {
      ...imageInfo,
      rowNr: rowNr,
      onClick: () => { alert('click ' + JSON.stringify(imageInfo))}
    }

    // const key = 'x-' + nr + '-' + index + '-' + thumbnailSize;
    const key = latestStore.getImageKey(enhancedImageInfo, thumbnailSize);

    return (
      <ScrollImage key={key} imageInfo={enhancedImageInfo} />
    );
  });

  if (isLast && isRowVisible && !didWarning) {
    console.log('last row is visible: ' + latestCursor);
    business.loadMoreData(latestCursor);
    setDidWarning(true);
  }

  if (rowImages[0]) {
    if (isLast) {
      return (
        <div ref={rowRef}>{rowImages}</div>
      );
    } else {
      return (
        <div>{rowImages}</div>
      );
    }
  }
  return null;
}

export default ScrollRow;
